import React, { useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import ButtonRound from '../../ButtonRound';
import styles from './Modal.scss';
import HouseDoiIcon from '../../../assets/img/houseDoi.svg';

const WelcomeText = ({ nextStep }) => {
    const [isLoading, setIsLoading] = useState(false);


    const goToNextStep = e => {
        e.preventDefault();
        nextStep();
    }

    return (
        <div>
            <DialogContent dividers={false}>
                <div className={styles.welcomeTextContainer}>
                    <div>
                        <HouseDoiIcon />
                    </div>
                    <div>
                        <p>Zum Schutz von dir und anderen Nutzenden möchten wir sicherstellen, dass du es wirklich bist. Dazu bitten wir dich, deine Mobilfunknummer zu verifizieren.</p><br></br>
                        <p>Wir geben deine Mobilfunknummer nicht weiter und veröffentlichen diese nicht.</p>
                    </div>
                </div>
                <div className={styles.phoneNumberButtons}>
                    {/* <Button type="submit" variant="outlined" className={'button button--secondary'} isLoading={false}>
                        Hilfe
                    </Button> */}
                    <ButtonRound type="submit" className={'button button--primary'} isLoading={isLoading} onClick={goToNextStep}>
                        Weiter
                    </ButtonRound>
                </div>
            </DialogContent>
        </div>
    )
}

export default WelcomeText